.specialBadge {
  text-align: center;
  backdrop-filter: blur(16px);
  border-radius: 16px;
  min-width: 55px;
  max-width: fit-content;
  height: 24px;
  padding: 0 8px;
  white-space: nowrap;
  background-color: var(--colors-info-main);
  color: var(--colors-text-info);
}

.specialBadgeWithoutContainer {
  display: inline-block;
}
